import React from 'react';
import { Icon, TYPE_OUTLINE } from '@mds/mds-reactjs-library';
import Outline64Circle from '@mds/mds-icons/icons/svg/outline-64-circle.svg';

const LoadingIndicator = () => (
  <div className="loadingWrapper">
    <Icon fill="#2251FF" type={TYPE_OUTLINE} src={Outline64Circle} />
  </div>
);

export default LoadingIndicator;